const localUrl = 'http://localhost:3000';
// const uatUrl = 'http://demo320.dataart.com';
const qaUrl = 'http://gndscopedockerqa.vrn.dataart.net';
const devUrl = 'http://gndscopedocker.vrn.dataart.net';
// const stgUrl = 'http://demo320.dataart.com';

const personalDataPort = ':81';
const gsPort = ':82';
const clientsPort = ':83';
const providersPort = ':84';

const appName = process.env.REACT_APP_NAME;
const appStage = process.env.REACT_APP_STAGE;

const apiSuffix = '/api';
export const gsSuffix = appStage === 'stg' || appStage === 'prod' ? '' : '/groundscope';
export const clientsSuffix = appStage === 'stg' || appStage === 'prod' ? '' : '/customers';
export const providersSuffix = appStage === 'stg' || appStage === 'prod' ? '' : '/partners';

const getUrl = (baseUrl: string, port?: string, suffix?: string) => {
	return `${baseUrl}${port || ''}${suffix || ''}`;
};

const gsApiBaseUrl = {
	local: getUrl(devUrl, gsPort, apiSuffix),
	dev: getUrl(devUrl, gsPort, apiSuffix),
	qa: getUrl(qaUrl, gsPort, apiSuffix),
	uat: getUrl('https://demo320.dataart.com', gsPort, apiSuffix),
	stg: getUrl('//stg-gswebapi.westeurope.azurecontainer.io', undefined, apiSuffix),
	prod: getUrl('//prod-gswebapi.uksouth.azurecontainer.io', undefined, apiSuffix),
};

const clientApiBaseUrl = {
	local: getUrl(devUrl, clientsPort, apiSuffix),
	dev: getUrl(devUrl, clientsPort, apiSuffix),
	qa: getUrl(qaUrl, clientsPort, apiSuffix),
	uat: getUrl('https://demo320.dataart.com', clientsPort, apiSuffix),
	stg: getUrl('//stg-gsclientswebapi.westeurope.azurecontainer.io', undefined, apiSuffix),
	prod: getUrl('//prod-gsclientswebapi.uksouth.azurecontainer.io', undefined, apiSuffix),
};

const providerApiBaseUrl = {
	local: getUrl(devUrl, providersPort, apiSuffix),
	dev: getUrl(devUrl, providersPort, apiSuffix),
	qa: getUrl(qaUrl, providersPort, apiSuffix),
	uat: getUrl('https://demo320.dataart.com', providersPort, apiSuffix),
	stg: getUrl('//stg-gsproviderswebapi.westeurope.azurecontainer.io', undefined, apiSuffix),
	prod: getUrl('//prod-gsproviderswebapi.uksouth.azurecontainer.io', undefined, apiSuffix),
};

const baseUrl = {
	gs: {
		local: getUrl(localUrl, undefined, gsSuffix),
		dev: getUrl(devUrl, undefined, gsSuffix),
		qa: getUrl(qaUrl, undefined, gsSuffix),
		uat: getUrl('http://demo320.dataart.com', undefined, gsSuffix),
		stg: getUrl(
			window.location.protocol + '//stg-gs.groundscope.co.uk', // '//groundscope.azureedge.net', 
			undefined, 
			gsSuffix), // stg: getUrl('http://gsfrontend.westeurope.azurecontainer.io', undefined, gsSuffix)
		prod: getUrl(
			window.location.protocol + '//prod-gs.groundscope.co.uk', // window.location.protocol + '//prod-groundscope.azureedge.net',
			undefined,
			gsSuffix
		),
	},
	providers: {
		local: getUrl(localUrl, undefined, providersSuffix),
		dev: getUrl(devUrl, undefined, providersSuffix),
		qa: getUrl(qaUrl, undefined, providersSuffix),
		uat: getUrl('http://demo320.dataart.com', undefined, providersSuffix),
		stg: getUrl(
			window.location.protocol + '//stg-partners.groundscope.co.uk', // '//gs-partners.azureedge.net',
			undefined,
			providersSuffix
		), // stg: getUrl('http://gsfrontend.westeurope.azurecontainer.io', undefined, providersSuffix)
		prod: getUrl(
			window.location.protocol + '//prod-partners.groundscope.co.uk', // window.location.protocol + '//prod-gs-partners.azureedge.net',
			undefined,
			providersSuffix
		),
	},
	clients: {
		local: getUrl(localUrl, undefined, clientsSuffix),
		dev: getUrl(devUrl, undefined, clientsSuffix),
		qa: getUrl(qaUrl, undefined, clientsSuffix),
		uat: getUrl('http://demo320.dataart.com', undefined, clientsSuffix),
		stg: getUrl(
			window.location.protocol + '//stg-customers.groundscope.co.uk', // '//gs-customers.azureedge.net',
			undefined,
			clientsSuffix
		), // stg: getUrl('http://gsfrontend.westeurope.azurecontainer.io', undefined, clientsSuffix)
		prod: getUrl(
			window.location.protocol + '//prod-customers.groundscope.co.uk', // window.location.protocol + '//prod-gs-customers.azureedge.net',
			undefined,
			clientsSuffix
		),
	},
};

const personalDataApiBaseUrl = {
	local: getUrl(devUrl, personalDataPort, apiSuffix),
	dev: getUrl(devUrl, personalDataPort, apiSuffix),
	qa: getUrl(qaUrl, personalDataPort, apiSuffix),
	uat: getUrl('https://demo320.dataart.com', personalDataPort, apiSuffix),
	stg: getUrl('https://stg-gsidentityserver.groundscope.co.uk', undefined, apiSuffix), // stg: getUrl('https://gsidentityserver.westeurope.azurecontainer.io', undefined, apiSuffix),
	prod: getUrl('https://prod-gsidentityserver.groundscope.co.uk', undefined, apiSuffix), // prod: getUrl('https://prod-gsidentityserver.uksouth.azurecontainer.io', undefined, apiSuffix),
};

const idServUrl = {
	local: getUrl(devUrl, personalDataPort),
	dev: getUrl(devUrl, personalDataPort),
	qa: getUrl(qaUrl, personalDataPort),
	uat: getUrl('https://demo320.dataart.com', personalDataPort),
	stg: getUrl('https://stg-gsidentityserver.groundscope.co.uk', undefined), // stg: getUrl('https://gsidentityserver.westeurope.azurecontainer.io', undefined), // stg: getUrl('http://gsidentityserver.westeurope.azurecontainer.io', undefined),
	prod: getUrl('https://prod-gsidentityserver.groundscope.co.uk', undefined), // prod: getUrl('https://prod-gsidentityserver.uksouth.azurecontainer.io', undefined),
};

const idServConfig = {
	gs: {
		scope: 'openid profile email phone gs-web-api identity-web-api.readBookingPassenger.fe',
		client_id: 'gs-web-api-spa-client',
	},
	clients: {
		scope: 'openid profile email phone clients-web-api identity-web-api.readBookingPassenger.fe identity-web-api.saveBookingPassenger.fe',
		client_id: 'clients-web-api-spa-client',
	},
	providers: {
		scope: 'openid profile email phone providers-web-api identity-web-api.readBookingPassenger.fe',
		client_id: 'providers-web-api-spa-client',
	},
};

const stripePublicKey = 'pk_test_71fQckYb5pwUNTaIuGRrkL1E00OKU9joJc';

const config = {
	baseUrl: baseUrl[appName || ''][appStage || 'dev'],
	providerApiBaseUrl: providerApiBaseUrl[appStage || 'dev'],
	clientApiBaseUrl: clientApiBaseUrl[appStage || 'dev'],
	gsApiBaseUrl: gsApiBaseUrl[appStage || 'dev'],
	personalDataApiBaseUrl: personalDataApiBaseUrl[appStage || 'dev'],
	idServUrl: idServUrl[appStage || 'dev'],
	idServConfig: idServConfig[appName || ''],
	idleTimeout: process.env.NODE_ENV !== 'production' ? 1000 * 60 * 60 * 10 : 1000 * 60 * 20, // 20 min prod 10 hs dev,
	stripePublicKey,
	headers: {
		'X-Requested-With': 'XMLHttpRequest',
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Cache-Control': 'no-cache',
	},
};

export default config;
